export default "__VITE_ASSET__YJGYH0Ts__"